import UserActions from "../Types";

const initialState = {
    isRegistering: false,
    registeredSuccess: false,
    verifiedEmail: false,
    isVerifying: false,
    verificationStatus: {},
    newUser: {},
    reVerifying: false,
    reVerificationStatus: {},
    verifiedUser: {},
    reVerifiedEmail: false,
    newUserStaff: {},
    isAdding: false,
    addingSuccess: false,
    isUploading: false,
    uploadSuccess: false,
    uploadedDoc: {},
    isUpdating: false,
    updateSuccess: false,
    updatedDoc: {},
    error: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case UserActions.USER_REGISTER_START:
            return {
                ...state,
                isRegistering: true,
                registeredSuccess: false,
                error: null
            }
        case UserActions.USER_REGISTER_SUCCESS:
            return {
                ...state,
                isRegistering: false,
                registeredSuccess: true,
                newUser: action.payload,
                error: null
            }
        case UserActions.USER_REGISTER_FAILURE:
            return {
                ...state,
                isRegistering: false,
                registeredSuccess: false,
                error: action.payload
            }
        case UserActions.VERIFY_EMAIL_START:
            return {
                ...state,
                isVerifying: true,
                verifiedEmail: false,
                error: null
            }
        case UserActions.VERIFY_EMAIL_SUCCESS:
            return {
                ...state,
                isVerifying: false,
                verifiedEmail: true,
                verificationStatus: action.payload,
                error: null
            }
        case UserActions.VERIFY_EMAIL_FAILURE:
            return {
                ...state,
                isVerifying: false,
                verifiedEmail: false,
                error: action.payload
            }
        case UserActions.RESEND_VERIFICATION_START:
            return {
                ...state,
                reVerifying: true,
                reVerifiedEmail: false,
                error: null
            }
        case UserActions.RESEND_VERIFICATION_SUCCESS:
            return {
                ...state,
                reVerifying: false,
                reVerifiedEmail: true,
                reVerificationStatus: action.payload,
                error: null
            }
        case UserActions.RESEND_VERIFICATION_FAILURE:
            return {
                ...state,
                reVerifying: false,
                reVerifiedEmail: false,
                error: action.payload
            }
        case UserActions.ADD_STAFF_START:
            return {
                ...state,
                isAdding: true,
                addingSuccess: false,
                error: null
            }
        case UserActions.ADD_STAFF_SUCCESS:
            return {
                ...state,
                isAdding: false,
                addingSuccess: true,
                newUserStaff: action.payload,
                error: null
            }
        case UserActions.ADD_STAFF_FAILURE:
            return {
                ...state,
                isAdding: false,
                addingSuccess: false,
                error: action.payload
            }
        case UserActions.UPLOAD_DOC_START:
            return {
                ...state,
                isUploading: true,
                uploadSuccess: false,
                error: null
            }
        case UserActions.UPLOAD_DOC_RESET:
            return {
                ...state,
                isAdding: false,
                addingSuccess: false,
                isUploading: false,
                uploadSuccess: false,
                uploadedDoc: {},
                isUpdating: false,
                updateSuccess: false,
                updatedDoc: {},
                error: null
            }
        case UserActions.UPLOAD_DOC_SUCCESS:
            return {
                ...state,
                isUploading: false,
                uploadSuccess: true,
                uploadedDoc: action.payload,
                error: null
            }
        case UserActions.UPLOAD_DOC_FAILURE:
            return {
                ...state,
                isUploading: false,
                uploadSuccess: false,
                error: action.payload
            }
        case UserActions.UPDATE_DOC_START:
            return {
                ...state,
                isUpdating: true,
                updateSuccess: false,
                error: null
            }
        case UserActions.UPDATE_DOC_SUCCESS:
            return {
                ...state,
                isUpdating: false,
                updateSuccess: true,
                updatedDoc: action.payload,
                error: null
            }
        case UserActions.UPDATE_DOC_FAILURE:
            return {
                ...state,
                isUpdating: false,
                updateSuccess: false,
                error: action.payload
            }
        case UserActions.CLEAR_VERIFY_EMAIL_STATE:
            return initialState;
        default:
            return state;
    }
}